<template>
    <div v-if="documentHash" class="bulma comment-container">
        <comment-deletion-confirmation-modal />
        <comment-error-document-deleted-modal />
        <h1>{{ commentsAmountTitle }}</h1>
        <new-comment v-if="this.initIsUserCanComment" />
        <div class="mt-1">
            <comment :key="comment.hash_id" v-for="comment in comments" :comment="comment"></comment>
        </div>
        <loading-block v-show="isLoadingComments" :message="trans.loader_message" />
        <load-comments-button class="mb-1" v-if="isLoadCommentsButtonShown" />
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

import Comment from "./Comment";
import NewComment from "./NewComment";
import EditComment from "./EditComment";
import CommentDeletionConfirmationModal from "./CommentDeletionConfirmationModal";
import LoadCommentsButton from "./LoadCommentsButton";
import LoadingBlock from "../../../utils/LoadingBlock";
import CommentErrorDocumentDeletedModal from "./CommentErrorDocumentDeletedModal";

export default {
    name: "CommentMain",
    components: {
        CommentErrorDocumentDeletedModal,
        LoadingBlock,
        LoadCommentsButton,
        NewComment,
        Comment,
        EditComment,
        CommentDeletionConfirmationModal,
    },
    props: {
        initTrans: Object,
        initActions: Object,
        initCurrentUser: null,
        initIsUserCanComment: null,
        isInfiniteScrolled: false,
    },
    mounted() {
        if (this.isInfiniteScrolled) {
            window.addEventListener("scroll", this.onScroll);
        }

        this.setActions(this.initActions);
        this.setTrans(this.initTrans);
        this.setCurrentUser(this.initCurrentUser);
        this.setUserCanComment(this.initIsUserCanComment);
    },
    beforeDestroy() {
        if (this.isInfiniteScrolled) {
            window.removeEventListener("scroll", this.onScroll);
        }
    },
    computed: {
        ...mapGetters('comment', [
            'trans',
            'comments',
            'documentHash',
            'paginationSummary',
            'canLoadMoreComments',
            'isLoadingComments',
            'isRequestInProgress',
        ]),
        commentsAmountTitle() {
            return this.trans.amount_title_some;
        },
        isLoadCommentsButtonShown() {
            return !this.isLoadingComments
                && this.canLoadMoreComments
                && !this.isInfiniteScrolled;
        },
    },
    methods: {
        ...mapActions('comment', [
            'setActions',
            'setTrans',
            'setCurrentUser',
            'setUserCanComment',
            'loadComments',
            'resetCommentState',
            'setRequestInProgress',
        ]),
        onScroll() {
            if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 100) {
                if (this.isRequestInProgress || !this.paginationSummary) {
                    return ;
                }

                if (this.canLoadMoreComments) {
                    this.loadComments();
                }
            }
        },
    },
    watch: {
        documentHash(newValue, oldValue) {
            this.resetCommentState();
            this.loadComments();
        },
    }
}
</script>

<style lang="css" scoped>
    h1 {
        height: 19px;
        margin-top: 35px;
        margin-bottom: 30px;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 19px;
        display: flex;
        align-items: center;
    }

    div {
        width: calc(100% - 2px);
    }
</style>
